import React, { useState, useEffect } from 'react';
import { canInstall, showInstallPrompt } from '../utils/pwa';

function PwaInstallBanner() {
  const [show, setShow] = useState(false);
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    // Show install banner after a delay if installable
    const t = setTimeout(() => {
      if (canInstall() && !localStorage.getItem('apk_install_dismissed')) {
        setShow(true);
      }
    }, 5000);

    const handleOnline = () => setIsOffline(false);
    const handleOffline = () => setIsOffline(true);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      clearTimeout(t);
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const handleInstall = async () => {
    const accepted = await showInstallPrompt();
    if (accepted) setShow(false);
  };

  const handleDismiss = () => {
    setShow(false);
    localStorage.setItem('apk_install_dismissed', '1');
  };

  return (
    <>
      {isOffline && (
        <div style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 9999,
          background: '#ff6b5e', color: '#fff', textAlign: 'center',
          padding: '8px 16px', fontSize: 13, fontWeight: 600,
        }}>
          📡 You're offline — some features may not work
        </div>
      )}
      {show && (
        <div style={{
          position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 9998,
          background: '#0a1628', border: '1px solid #d4a843', borderRadius: 12,
          padding: 16, display: 'flex', alignItems: 'center', gap: 12,
          boxShadow: '0 8px 32px rgba(0,0,0,0.4)', maxWidth: 480, margin: '0 auto',
        }}>
          <div style={{ fontSize: 32 }}>📱</div>
          <div style={{ flex: 1 }}>
            <div style={{ color: '#fff', fontWeight: 700, fontSize: 14 }}>Add to Home Screen</div>
            <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: 12 }}>Install American Pub Poker for quick access</div>
          </div>
          <button onClick={handleInstall} style={{
            background: '#d4a843', color: '#0a1628', border: 'none',
            padding: '8px 16px', borderRadius: 6, fontWeight: 700, cursor: 'pointer'
          }}>Install</button>
          <button onClick={handleDismiss} style={{
            background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)',
            fontSize: 24, cursor: 'pointer', padding: '0 4px'
          }}>×</button>
        </div>
      )}
    </>
  );
}

export default PwaInstallBanner;
